import { render } from "./switchCheckbox.vue?vue&type=template&id=930c01b2&scoped=true&ts=true"
import script from "./switchCheckbox.ts?vue&type=script&lang=ts"
export * from "./switchCheckbox.ts?vue&type=script&lang=ts"

import "./switchCheckbox.scss?vue&type=style&index=0&id=930c01b2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-930c01b2"]])

export default __exports__